"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HookablePureComponent = exports.HookableComponent = exports.makeHookable = void 0;
var react_1 = require("react");
/* tslint:disable:max-classes-per-file */
function makeHookable(self) {
    var _a;
    var origRender = self.render.bind(self);
    var origCdu = (_a = self.componentDidUpdate) === null || _a === void 0 ? void 0 : _a.bind(self);
    var isParentRendering = false;
    var snapshot;
    var layoutEffect = function () {
        if (!isParentRendering)
            origCdu === null || origCdu === void 0 ? void 0 : origCdu(self.props, self.state, snapshot);
        isParentRendering = false;
    };
    var elemFunc = function () {
        var _a, _b;
        var res = origRender();
        if (!isParentRendering)
            snapshot =
                (_b = (_a = self.getSnapshotBeforeUpdate) === null || _a === void 0 ? void 0 : _a.call(self, self.props, self.state)) !== null && _b !== void 0 ? _b : undefined;
        (0, react_1.useLayoutEffect)(layoutEffect);
        return res;
    };
    self.render = function () {
        isParentRendering = true;
        return (0, react_1.createElement)(elemFunc, null);
    };
}
exports.makeHookable = makeHookable;
var HookableComponent = /** @class */ (function (_super) {
    __extends(HookableComponent, _super);
    function HookableComponent(props) {
        var _this = _super.call(this, props) || this;
        makeHookable(_this);
        return _this;
    }
    return HookableComponent;
}(react_1.Component));
exports.HookableComponent = HookableComponent;
var HookablePureComponent = /** @class */ (function (_super) {
    __extends(HookablePureComponent, _super);
    function HookablePureComponent(props) {
        var _this = _super.call(this, props) || this;
        makeHookable(_this);
        return _this;
    }
    return HookablePureComponent;
}(react_1.PureComponent));
exports.HookablePureComponent = HookablePureComponent;
